import * as vp from 'vopay';
import { useTranslation } from 'react-i18next';
import { OpenDialogProps, Dialog } from '@/providers/Dialog.provider';
import styles from './NoOperationalDefault.module.scss';

const classes = vp.withStyles(styles);
const { Box, Button, Icon } = vp;

const NoOperationalDefault: React.FC<OpenDialogProps<string>> = ({ onConfirm, onCancel }) => {
  const { t } = useTranslation('translations', { keyPrefix: 'SubAccounts.NoOperationalDefault' });

  return (
    <Box
      flx="col"
      ai="center"
      boundary="shadow"
      background="white"
      position="relative"
      padding="44px 32px"
      borderRadius="15px"
      gap="md"
      maxwidth="483px"
    >
      <Icon icon="close2" onClick={onCancel} height="14px" width="14px" className={classes('closeButton')} />

      <Box flx="col" ai="center" base="8" gap="md">
        <Dialog.Title hidden>{t('title')}</Dialog.Title>

        <h2 className={classes('header')} aria-hidden>
          {t('title')}
        </h2>

        <Box flx="row" base="8" ai="center" gap="md">
          <Icon icon="bank2" />

          <Box flx="col">
            <h3 className={classes('secondaryHeader')}>{t('step1Header')}</h3>
            <p className={classes('description')}>{t('step1Description')}</p>
          </Box>
        </Box>

        <Box flx="row" base="8" gap="md" ai="center">
          <Icon icon="accountingCredits" />

          <Box flx="col">
            <h3 className={classes('secondaryHeader')}>{t('step2Header')}</h3>
            <p className={classes('description')}>{t('step2Description')}</p>
          </Box>
        </Box>

        <Box base="8" pt="md" flx="col" width="100%">
          <Button
            label={t('goToOperationalAccounts')}
            color="primary"
            height="30px"
            width="100%"
            onClick={() => {
              onConfirm('done');
            }}
          />
        </Box>
      </Box>
    </Box>
  );
};

export default NoOperationalDefault;
